import React, { useEffect, useState } from "react";
import Input from "../../Input";
import Button from "../../Button";
import { ButtonNew, Buttons, Card, Contanier, Forms, Gruop, Header, Title, paragrafo } from "./style";
import { Alert } from "../../../utils/Alert";
import Icone from "../../../utils/Icone";
import api from "../../../Services/api";
import { format } from "date-fns";

export default function ResetarSenha({ resetEvent, setResetEvent }) {
  if (resetEvent == false) {
    return null;
  }
  const [rm, setRm] = useState("");
  const [nome, setNome] = useState("");
  const [DataNascimento, setDataNascimento] = useState("");
  const [DataInicio, setDataInicio] = useState("");
  const [DataTermino, setDataTermino] = useState("");
  const [Email, setEmail] = useState("");
  const [Curso, setCurso] = useState("");

  useEffect(() => {
    if (resetEvent == false) {
      return;
    }

    const delayDebounceFn = setTimeout(() => {
      if (rm.length >= 5) {
        porcurarAluno();
      } else {
        clearUserData();
      }
    }, 500); // Espera 500ms após o usuário parar de digitar

    return () => clearTimeout(delayDebounceFn);
  }, [rm, resetEvent]);

  function clearUserData() {
    setNome("");
    setDataNascimento("");
    setDataInicio("");
    setDataTermino("");
    setEmail("");
    setCurso("");
  }

  async function porcurarAluno() {
    try {
      const { data } = await api.get(`/aluno/buscar?rm=${rm}`);
      if (data) {
        setNome(data.nome);
        setDataNascimento(data.dt_nascimento);
        setDataInicio(data.dt_inicio);
        setDataTermino(data.dt_termino);
        setEmail(data.email);
        setCurso(data.nome_curso);
      } else {
        Alert({ tipo: "Erro-popup", mensagem: "Aluno não encontrado", tempo: 3000 });
        clearUserData();
      }
    } catch (erro) {
      console.clear();
      Alert({ tipo: "Erro-popup", mensagem: "Aluno não encontrado", tempo: 3000 });
      clearUserData();
    }
  }

  async function resetUser(rm) {
    try {
      const response = await api.put(`/aluno/restaurar-senha?rm=${rm}`);
      if (response.status == 200) {
        Alert({ tipo: "Sucesso", mensagem: "Senha resetada com sucesso!" });
        setResetEvent(false);
      } else {
        Alert({ tipo: "Erro", mensagem: "Erro ao resetar senha do aluno" });
      }
    } catch (err) {
      Alert({ tipo: "Erro", mensagem: "Erro ao resetar senha do aluno" });
      console.log(err);
    }
  }

  return (
    <Contanier>
      <Card>
        <Header>
          <Buttons
            onClick={() => {
              setRm("");
              clearUserData();
              setResetEvent(false);
            }}
          >
            <Icone name={"X"} color={" #3a3f86"} size={50} />
          </Buttons>
          <Title>Resetar Senha</Title>
        </Header>
        <Forms>
          <ButtonNew>
            <Input
              widthDiv="8rem"
              color="black"
              type={"text"}
              placeholdercolor="black"
              placeholder="Digite o RM"
              required={true}
              event={(e) => setRm(e.target.value)}
            />
          </ButtonNew>
          <Gruop>
            {nome && (
              <paragrafo>
                <strong>Nome: </strong>
                {nome}
              </paragrafo>
            )}
            {DataNascimento && (
              <paragrafo>
                <strong>Nascimento: </strong>
                {format(new Date(DataNascimento), "dd/MM/yyyy")}
              </paragrafo>
            )}
            {Email && (
              <paragrafo>
                <strong>Email: </strong>
                {Email}
              </paragrafo>
            )}
            {Curso && (
              <paragrafo>
                <strong>Curso: </strong>
                {Curso}
              </paragrafo>
            )}
          </Gruop>
        </Forms>
        <Button id={"button"} width="20vh" height="4rem" event={() => resetUser(rm)} placeholder={"Resetar"} />
        <br />
        <small>
          <strong>A senha do aluno retornará para data de nascimento dele!</strong>
        </small>
      </Card>
    </Contanier>
  );
}
